import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, PenTool, CheckSquare, Mail } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function OfferBonuses() {
  const bonuses = [{
    icon: <PenTool className="w-6 h-6" data-id="element-173" data-mp="4017pic7sfra" />,
    title: 'BONUS #1: Plantillas de Gratitud',
    desc: 'Un set de herramientas para integrar el hábito de la gratitud en tu vida diaria (21 días).'
  }, {
    icon: <CheckSquare className="w-6 h-6" data-id="element-174" data-mp="dyh1xu6jg550" />,
    title: 'BONUS #2: Checklist de 21 días - "Sanando tu Niña Interior"',
    desc: 'Un proceso guiado para reconectar con tu historia emocional y transformar tu amor propio.'
  }, {
    icon: <Mail className="w-6 h-6" data-id="element-175" data-mp="rqnhpf5s4a3x" />,
    title: 'BONUS #3: Plantillas de Cartas Terapéuticas',
    desc: 'Guías para escribir cartas que te ayuden a cerrar ciclos, liberar emociones y sanar relaciones.'
  }];
  return <section className="bg-brown-dark text-cream-light py-20 md:py-32 relative overflow-hidden" data-id="element-176" data-mp="11obdm8f4fnno">
      {/* Background texture */}
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: "url(\"data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E\")"
    }} data-id="element-177" data-mp="3mhhhngg5f2g7"></div>

      <div className="max-w-5xl mx-auto px-6 relative z-10" data-id="element-178" data-mp="43gubbl8spav">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16 space-y-4" data-id="element-179" data-mp="3vgkwu9c72xpf">
          <h2 className="text-3xl md:text-5xl font-playfair font-bold text-gold-main" data-id="element-180" data-mp="n1az1dfc8eng">
            Hoy no solo obtienes el ebook completo.
          </h2>
          <p className="font-lora text-xl text-cream-dark/80" data-id="element-181" data-mp="2hbhqtb0jpd7m">
            También recibirás 3 bonos exclusivos incluidos sin costo adicional.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start" data-id="element-182" data-mp="27j2a0h0ziuob">
          {/* Main Product Card */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="lg:col-span-5 bg-cream-light text-brown-dark p-8 rounded-sm shadow-2xl" data-id="element-183" data-mp="2cglptldbzfid">
            <div className="flex items-center gap-3 text-gold-dark mb-6 border-b border-gold-main/20 pb-4" data-id="element-184" data-mp="1tklt5x9ernsg">
              <BookOpen className="w-8 h-8" data-id="element-185" data-mp="3iza6q1tqjbs2" />
              <h3 className="text-2xl font-playfair font-bold" data-id="element-186" data-mp="3nxva2a4aabkq">
                El eBook Completo
              </h3>
            </div>
            <ul className="space-y-3 font-lora text-sm" data-id="element-187" data-mp="1cbjjw0a4gyez">
              <li className="flex items-start gap-2" data-id="element-188" data-mp="17bf46ch1g7pt">
                <span className="text-gold-main mt-0.5" data-id="element-189" data-mp="17cq94fm7zlii">✓</span>
                <span data-id="element-190" data-mp="1m0tf3p09ix7b">Más de 200 páginas de contenido profundo</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-191" data-mp="1h9uw2hnw3l0d">
                <span className="text-gold-main mt-0.5" data-id="element-192" data-mp="1h805ontun0ow">✓</span>
                <span data-id="element-193" data-mp="1v0840k0s6zpp">Ceremonias de Unión</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-194" data-mp="1qzeexnblrev8">
                <span className="text-gold-main mt-0.5" data-id="element-195" data-mp="1qymiybe3ff4f">✓</span>
                <span data-id="element-196" data-mp="24zp6kskqkxhg">
                  Ceremonias de Bienvenida al mundo y bendición de nombre
                </span>
              </li>
              <li className="flex items-start gap-2" data-id="element-197" data-mp="200m0d4t0sl7w">
                <span className="text-gold-main mt-0.5" data-id="element-198" data-mp="akwa6rc142og">✓</span>
                <span data-id="element-199" data-mp="an8rd29yq90g">Ritual de cumpleaños</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-200" data-mp="5n3561mgpepr">
                <span className="text-gold-main mt-0.5" data-id="element-201" data-mp="738m97u4hql7">✓</span>
                <span data-id="element-202" data-mp="72yvvj561hez">Ritual para Transiciones difíciles</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-203" data-mp="c10ddzmy18oc">
                <span className="text-gold-main mt-0.5" data-id="element-204" data-mp="h1el1gkmuglu">✓</span>
                <span data-id="element-205" data-mp="h267a0scb1zg">Ritual para Cierre de ciclos</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-206" data-mp="lzg2xy6bo9vq">
                <span className="text-gold-main mt-0.5" data-id="element-207" data-mp="3ki50em23u607">✓</span>
                <span data-id="element-208" data-mp="3kjy721cpwq87">
                  Ritual para Cierre de año e inicio de uno nuevo (con mapa de
                  sueños)
                </span>
              </li>
              <li className="flex items-start gap-2" data-id="element-209" data-mp="3uf9nco3ry5i2">
                <span className="text-gold-main mt-0.5" data-id="element-210" data-mp="3uegbx9tvertl">✓</span>
                <span data-id="element-211" data-mp="336jevcnir4c">Ritual para Atraer más abundancia</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-212" data-mp="31qkjihbc3m2m">
                <span className="text-gold-main mt-0.5" data-id="element-213" data-mp="31psvbrk2gqmd">✓</span>
                <span data-id="element-214" data-mp="36p5iyeiri1q0">Ritual para Desarrollar tu intuición</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-215" data-mp="1nukl46x7p2es">
                <span className="text-gold-main mt-0.5" data-id="element-216" data-mp="1ju0nz3cn1ysn">✓</span>
                <span data-id="element-217" data-mp="1juik7zzawd0k">Ritual para Construir y potenciar tu amor propio</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-218" data-mp="1etcodtacg9mt">
                <span className="text-gold-main mt-0.5" data-id="element-219" data-mp="19wcgdctxowt2">✓</span>
                <span data-id="element-220" data-mp="19xxa508fcbpv">Rituales para atravesar un duelo</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-221" data-mp="14yaw4okrurg0">
                <span className="text-gold-main mt-0.5" data-id="element-222" data-mp="105htq7crzv73">✓</span>
                <span data-id="element-223" data-mp="103wz6hqgoc98">Rituales de pareja para fortalecer el vínculo</span>
              </li>
            </ul>
          </motion.div>

          {/* Bonuses List */}
          <div className="lg:col-span-7 space-y-4" data-id="element-224" data-mp="r6ecza12zrvr">
            {bonuses.map((bonus, idx) => <motion.div key={idx} initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.15
          }} className="bg-brown-light/30 border border-gold-main/20 p-6 rounded-sm flex gap-4 items-start" data-id="element-225" data-mp="m574f8r46oo1" data-mpi={idx}>
                <div className="bg-gold-main/20 p-3 rounded-sm text-gold-main flex-shrink-0" data-id="element-226" data-mp="2m9s40650udn">
                  {bonus.icon}
                </div>
                <div data-id="element-227" data-mp="v82p1t4r5esi">
                  <h4 className="text-xl font-playfair font-semibold text-gold-main mb-2" data-id="element-228" data-mp="v8m3gzv71l1s">
                    {bonus.title}
                  </h4>
                  <p className="font-lora text-cream-dark/80" data-id="element-229" data-mp="lj2k7t3kjp6e">{bonus.desc}</p>
                </div>
              </motion.div>)}
          </div>
        </div>

        {/* Price & CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="mt-20 text-center bg-cream-light text-brown-dark p-10 md:p-16 rounded-sm max-w-3xl mx-auto shadow-2xl" data-id="element-230" data-mp="1dzde04qx3hhr">
          <h3 className="text-2xl font-playfair font-bold mb-6" data-id="element-231" data-mp="33hsfzu0smecu">
            Valor total del paquete
          </h3>

          <div className="flex justify-center items-center gap-4 mb-8 font-lora text-lg" data-id="element-232" data-mp="2frojs7pxpgvv">
            <span className="line-through text-brown-light/60" data-id="element-233" data-mp="2atd95urtf2cl">
              Valor real: $47+
            </span>
            <span className="text-gold-main" data-id="element-234" data-mp="2pqnkn44gk88b">→</span>
            <span className="font-bold" data-id="element-235" data-mp="2kpq40vz3jm8x">Hoy disponible por:</span>
          </div>

          <div className="text-6xl md:text-7xl font-playfair font-bold text-gold-dark mb-4" data-id="element-236" data-mp="4yv77iojdkza">
            $14.99 <span className="text-2xl text-brown-light" data-id="element-237" data-mp="ahid6wujp3">USD</span>
          </div>

          <p className="font-lora text-brown-light mb-8" data-id="element-238" data-mp="2d40n8utup2">
            Pago único · Acceso inmediato
          </p>

          <CTAButton className="w-full sm:w-auto px-12 py-5 text-xl" data-id="element-239" data-mp="1yhkppejtyqnh">
            Quiero acceder ahora
          </CTAButton>
        </motion.div>
      </div>
    </section>;
}